import partners from "../img/partners.png"
import partners2 from "../img/partners2.png"
import partners3 from "../img/partners3.png"
import partners4 from "../img/partners4.png"

export const Partners = () =>{
    return(
        <div className="flex container1 partners" >
            <img src={partners} />
            <img src={partners2} />
            <img src={partners3} />
            <img src={partners4} />
        </div>
    )
}

